export default __webpack_public_path__ + "71e62b6d7fcf02dc8e3b86f6814eb58d.svg";